import React from "react";
import EditFlightContent from "../components/edit-flight-content";

const EditFlight = () => {
  return <EditFlightContent />;
};

export default EditFlight;
